import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ActionButton, Buttons } from "../../components/Buttons";
import { TextInputform, DropDown } from "../../components/Forms";
import { MdOutlineDelete } from "react-icons/md";
import { LiaEditSolid } from "react-icons/lia";
import { HiOutlineDotsVertical } from "react-icons/hi";
import PageTitle from "../../components/PageTitle";
import NotifyData from "../../components/NotifyData";
import Pagination from "../../components/Pagination";
import TableUI from "../../components/TableUI";
import { fetchComplaints, deleteComplaint } from "../../slice/ComplaintSlice";

const Complaint = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { complaints } = useSelector((state) => state.complaints);

  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const currentUserId = userData.user_id;

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    dispatch(fetchComplaints(searchTerm));
  }, [dispatch, searchTerm]);

  const handleCreate = () => {
    navigate("/complaint/create");
  };

  const handleEdit = (complaint) => {
    navigate(`/complaint/edit/${complaint.complaint_id}`);
  };

  const handleDelete = async (complaintId) => {
    if (!currentUserId) {
      NotifyData("Operation Failed: User not authenticated", "error");
      return;
    }

    try {
      const msg = await dispatch(
        deleteComplaint({ complaintId, currentUserId })
      ).unwrap();
      NotifyData(msg, "success");
      dispatch(fetchComplaints(searchTerm));
    } catch (error) {
      NotifyData(error.message, "error");
    }
  };

  // Search and status filter
  const filteredComplaints =
    complaints?.filter(
      (complaint) =>
        (complaint?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
          complaint?.customer_no
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase()) ||
          complaint?.description
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase())) &&
        (statusFilter === "" || complaint.status === statusFilter)
    ) || [];

  // Pagination logic
  const totalRecords = filteredComplaints.length;
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = filteredComplaints.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Table headers
  const headers = [
    "No",
    "Customer Name",
    "Box No",
    "Staff Name",
    "Description",
    "Status",
  ];

  // Table body
  const body = currentData.map((complaint, index) => {
    const statusStyles = {
      Pending: {
        backgroundColor: "#ffcccc",
        color: "#a30000",
        padding: "5px 10px",
        borderRadius: "4px",
      },
      "In Progress": {
        backgroundColor: "#fff4cc",
        color: "#666600",
        padding: "5px 10px",
        borderRadius: "4px",
      },
      Resolved: {
        backgroundColor: "#ccffcc",
        color: "#006600",
        padding: "5px 10px",
        borderRadius: "4px",
      },
    };

    return {
      key: complaint.complaint_id,
      values: [
        startIndex + index + 1,
        complaint.name,
        complaint.box_no,
        complaint.staff_name,
        complaint.description,
        <span style={statusStyles[complaint.status] || {}}>
          {complaint.status}
        </span>,
        <ActionButton
          options={[
            {
              label: "Edit",
              icon: <LiaEditSolid />,
              onClick: () => handleEdit(complaint),
            },
            {
              label: "Delete",
              icon: <MdOutlineDelete />,
              onClick: () => handleDelete(complaint.complaint_id),
            },
          ]}
          label={<HiOutlineDotsVertical />}
        />,
      ],
    };
  });

  return (
    <div id="main">
      <Container fluid>
        <Row>
          <Col xs="6" className="py-3">
            <PageTitle PageTitle="Complaint" showButton={false} />
          </Col>
          <Col xs="6" className="py-3 text-end">
            {/* <Buttons
              btnlabel="Add New"
              className="add-btn"
              onClick={handleCreate}
            /> */}
          </Col>

          {/* Search */}
          <Col xs="12" lg="3" className="py-1">
            <TextInputform
              formLabel="Search "
              PlaceHolder="Search by customer name, number, or description"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </Col>
          {/* Status Filter */}
          <Col xs="12" lg="3" className="py-1">
            <DropDown
              textlabel="Status"
              name="statusFilter"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
              options={[
                { value: "", label: "All Statuses" },
                { value: "Pending", label: "Pending" },
                { value: "In Progress", label: "In Progress" },
                { value: "Resolved", label: "Resolved" },
              ]}
            />
          </Col>
          <Col xs="12" className="d-flex justify-content-end">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </Col>
          {/* Table */}
          <Col xs="12" className="py-3 tableui">
            <TableUI
              headers={headers}
              body={body}
              className="table"
              showActionColumn={true}
              noRecordMessage="No complaints found"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Complaint;
